import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2.5" }
const _hoisted_2 = { class: "h-9 w-9 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0" }
const _hoisted_3 = { class: "font-medium text-sm whitespace-nowrap" }

import { computed } from 'vue'
import type { HelpModuleConfig } from '@/types/help'
import {
  Rocket,
  LayoutDashboard,
  Building2,
  FolderKanban,
  ListTodo,
  ClipboardList,
  Layers,
  MessageSquarePlus,
  Ticket,
  PackageCheck,
  Users,
  Calendar,
  Video,
  FileText,
  Receipt,
  ShoppingCart,
  UserCog,
  Settings,
  Bot,
  Shield,
} from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'FloatingModuleCard',
  props: {
    module: {},
    x: {},
    y: {},
    rotation: {},
    scale: {},
    delay: {}
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props



const iconMap: Record<string, unknown> = {
  Rocket,
  LayoutDashboard,
  Building2,
  FolderKanban,
  ListTodo,
  ClipboardList,
  Layers,
  MessageSquarePlus,
  Ticket,
  PackageCheck,
  Users,
  Calendar,
  Video,
  FileText,
  Receipt,
  ShoppingCart,
  UserCog,
  Settings,
  Bot,
  Shield,
}

const icon = computed(() => iconMap[props.module.icon] || FileText)

const style = computed(() => ({
  left: `${props.x}px`,
  top: `${props.y}px`,
  transform: `rotate(${props.rotation}deg) scale(${props.scale})`,
  animationDelay: `${props.delay}ms`,
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "floating-card absolute p-3 bg-background/95 backdrop-blur border rounded-xl shadow-lg cursor-pointer select-none transition-all duration-200 hover:scale-110 hover:shadow-xl hover:border-primary/50 hover:z-10",
    style: _normalizeStyle(style.value),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(icon.value), { class: "h-4.5 w-4.5 text-primary" }))
      ]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.module.title), 1)
    ])
  ], 4))
}
}

})